// Consent to partners' cookies, asked of visitors where the law requires it (the EU and EEA, the UK and
// Switzerland): until they accept, no partner ad, script or ad network is loaded for them; if they
// decline, none ever is. The choice stays in their browser (components/ads/Consent.tsx).

/** Countries (lower-case ISO codes) whose visitors are asked: the EU 27, the rest of the EEA, the UK and Switzerland. */
export const CONSENT_COUNTRIES = new Set(
  "at be bg hr cy cz dk ee fi fr de gr hu ie it lv lt lu mt nl pl pt ro sk si es se is li no gb ch".split(" "),
);

export type ConsentChoice = "all" | "essential";
export const CONSENT_KEY = "sweet:consent";

export function readConsent(): ConsentChoice | null {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    return v === "all" || v === "essential" ? v : null;
  } catch {
    return null;
  }
}

export function writeConsent(choice: ConsentChoice | null) {
  try {
    if (choice) localStorage.setItem(CONSENT_KEY, choice);
    else localStorage.removeItem(CONSENT_KEY);
  } catch {}
}
